import { RestrictionEnum } from "@api-types/restriction/RestrictionEnum";
import { getWebApiUrl } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getMvcRequestHeaders } from "@utils/api-config/getMvcRequestHeaders";
import { httpClient } from "@utils/http/httpClient";

export default class RestrictionApiService {
	private static get baseUrl(): string {
		return `${getWebApiUrl()}/api/restriction`;
	}

	static getRequestHeaders = (
		context = getApiRequestContext()
	): HeadersInit => {
		const appHeaders = getMvcRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async getRestrictionType(): Promise<RestrictionEnum> {
		try {
			const { restrictionType } = await httpClient.get(
				this.baseUrl,
				this.getRequestHeaders()
			);
			return restrictionType;
		} catch (error) {
			console.log(error);
			return RestrictionEnum.None;
		}
	}
}
